module.exports = __webpack_public_path__ + "img/portada_pincho.5dc15365.jpg";